import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TimePicker from 'material-ui/TimePicker';
import Box from '../ui/Box';
import TextField from 'material-ui/TextField';

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper

export default class ManageServicesComponent extends Component {

	constructor() {
		super();
		this.state = {
			all_services: [],
			my_services: {},
			dialog: {
				open: false,
				head: 'Dude',
				body: 'This is working',
				actions: [
					<FlatButton
						label="Okay"
						primary
						onClick={this.closeDialog.bind(this)}
					/>
				]
			}
		}
	}

	componentDidMount() {
		this.getAllServices();
	}

	closeDialog(refresh = 0) {
		this.setState({
			dialog: {
				head: '',
				body: '',
				open: false,
				actions: []
			}
		})
		if (refresh) {
			this.getAllServices(0);
		}

	}

	getAllServices() {
		ds.getAllServices(
			data => {
        console.log('all services = ', data);
				this.setState({
					all_services: data
				}, () => {
					this.getMyServices();
				})
			}, 
			err => {}
		)
	}

	getMyServices() {
		ds.getMyServices(ls.getUserDetails().hotel_id,
			data => {
        let all_services = this.state.all_services;
				let x = {};
				for (let i of all_services) {
					x[i._id] = i;
					x[i._id].timings = [{
						from: "",
						to: ""
          }]
          
          if (i.name === 'Room Service') {
            x[i._id].meta = {};

            x[i._id].items = [''];
          }
        }

				if (data && data.services && data.services.length) {
					for (let i of data.services) {
            x[i.service].enabled = i.enabled ? true : false;
            
            if (i.meta) {
              x[i.service].meta = i.meta;
            }

            if (i.meta && i.meta.items) {
              x[i.service].items = i.meta.items;
            }

						if (i.timings && i.timings.length) {
							let timings = [];
							for (let j of i.timings) {
								timings.push({
									from: help.arihantsTimeToMatInput(j.from),
									to: help.arihantsTimeToMatInput(j.to),
								})
							}
							x[i.service].timings = timings;
						}
						else {
							//this.createNewTiming(i.service);
						}
					}
        }
				this.setState({
          my_services: x
          
				});
			}, err => {}
		)
	}

	createNewTiming(service_id) {
		let x = this.state.my_services;
		if (!x[service_id].timings) {
			x[service_id].timings = [];
		}
		x[service_id].timings.push({
			from: "",
			to: ""
		});

		this.setState({
			my_services: x
		})
	}

	removeTiming(service_id, ind) {
		let x = this.state.my_services;
		x[service_id].timings.splice(ind, 1);
		this.setState({
			my_services: x
		});
  }
  
  addItem(service_id) {
    let x = this.state.my_services;
		if (!x[service_id].items) {
			x[service_id].items = [];
    }
    
		x[service_id].items.push('');

		this.setState({
			my_services: x
		});
  }

  removeRoomItem(service_id, index, e) {
		let x = this.state.my_services;
    x[service_id].items.splice(index, 1);
    
		this.setState({
			my_services: x
		});
  }

	handleChanges(e) {
		this.setState({
			[e.target.name]: e.target.value
		})
	}

	saveServices(e) {
		e.preventDefault();
    let payload = this.getPayload();
		ds.postUpsertServices(payload, 
			data => {
				this.setState({
					dialog: {
						head: 'Success',
						body: 'Changes Saved',
						open: true,
						actions: [
							<FlatButton
								label="Okay"
								primary
								onClick={this.closeDialog.bind(this)}
							/>
						]
					}
				})
			}, 
			err => {}
		)
	}

	getPayload() {
		let p;
		p = {};
		p.hotel_id = ls.getUserDetails().hotel_id;
    p.services = [];
    
    let services = this.state.my_services;
    let c = 0;
    
		for (let i of Object.keys(services)) {
      const serviceObject = services[i];
      if (serviceObject && serviceObject.items) {
        p.services.push({
          service: i,
          enabled: services[i].enabled ? true : false,
          timings: [],
          meta: {
            items: serviceObject.items
          }
        });

      } else {
        p.services.push({
          service: i,
          enabled: services[i].enabled ? true : false,
          timings: []
        });
      }

			for (let j of services[i].timings) {
				p.services[c].timings.push({
					from: help.MatTimeToArihantsTime(j.from) || null,
					to: help.MatTimeToArihantsTime(j.to) || null
				})
			}
			c++;
		}
		return p;
	}

	render() {
		return (
			<Box header='Manage Services'>
				<div>
					<Dialog
						title={this.state.dialog.head}
						actions={this.state.dialog.actions}
						modal={false}
						open={this.state.dialog.open}
						onRequestClose={this.closeDialog.bind(this)}
					/>
					
					<form onSubmit={this.saveServices.bind(this)}>
						<div>
							<div className="col-sm-12 pb-1rem">
								<RaisedButton
									label="Save Changes"
									primary
									className="pull-right"
									type="submit"
								/>
							</div>
						</div>

						<div>
							{
								this.state.my_services && Object.keys(this.state.my_services) && Object.keys(this.state.my_services).length ?
									Object.keys(this.state.my_services).map((service) => {
										return (
											<section key={service} className="col-sm-12">
												<section className="col-sm-4" style={{marginTop: '0.7rem'}}>
													<Checkbox type="checkbox" name="remember" checked={this.state.my_services[service].enabled}
														onCheck={
															(e) => {
																let x = this.state.my_services;
																x[service].enabled = e.target.checked;
																this.setState({
																	my_services: x
																})
															}
														} 
													label={this.state.my_services[service].name} 
												/>
												</section>

												{
													this.state.my_services[service].timings && this.state.my_services[service].enabled ?
														<section className="col-sm-8">
															<label className="col-sm-2" style={{marginTop: '0.7rem'}}>Timings:</label> <br/>
															<div className="col-sm-12">
																{
																	this.state.my_services[service].timings.map((timing, ind) => {
																		return (
																			<div key={ind + 'timing'}>
																				<section className="col-sm-5 zeroPadding">
																					<TimePicker
																						format="ampm"
																						autoOk
																						hintText="From"
																						className="col-sm-6 w-100 timeinput-200 zeroPadding"
																						value={this.state.my_services[service].timings[ind].from}
																						onChange={(e, value) => {
																							let x = this.state.my_services;
																							this.state.my_services[service].timings[ind].from = value;
																							this.setState({
																								my_services: x
																							})
																						}}
																					/>
																				</section>

																				<section className="col-sm-5 zeroPadding">
																					<TimePicker
																						format="ampm"
																						autoOk
																						hintText="To"
																						className="col-sm-6 w-100 timeinput-200 zeroPadding"
																						value={this.state.my_services[service].timings[ind].to}
																						onChange={(e, value) => {
																							let x = this.state.my_services;
																							this.state.my_services[service].timings[ind].to = value;
																							this.setState({
																								my_services: x
																							})
																						}}
																					/>
																				</section>

																			{
																				this.state.my_services[service].timings.length > 1 ?
																					<section className="col-sm-1 pt-2vw font-1-7rem">
																						<IconButton onClick={this.removeTiming.bind(this, service, ind)}>
																							<i className="material-icons warn-fg">delete</i>
																						</IconButton>
																					</section> 
																				: null
																			}

																			{
																				ind == this.state.my_services[service].timings.length - 1 ?
																					<section className="col-sm-1 pt-2vw font-1-7rem">
																						<IconButton onClick={this.createNewTiming.bind(this, service)}>
																							<i className="material-icons link-fg">add</i>
																						</IconButton>
																					</section> 
																				: null
																			}
																			<br/>
																		</div>
																		)
																	})
																}
															</div>
														</section> 
													: null
												}

                        {
                          this.state.my_services[service].name === 'Room Service' && this.state.my_services[service].enabled ?
                            <div>
                              <section className="col-sm-4"></section>

                              <section className="col-sm-8">
                                <label className="col-sm-12" style={{marginTop: '0.2rem'}}>
                                  Items for Room Service:
                                </label> 
                                
                                <br/>

                                <div className="col-sm-12">
                                  {
                                    this.state.my_services[service].items.map((item, index) => {
                                      return (
                                        <div key={index + 'item______'}>
                                          <section className="col-sm-8 pr-1vw">
                                            <TextField
                                              name="itemName"
                                              className="w-100"
                                              value={item}
                                              placeholder="Enter Name Here"
                                              onChange={(e, value) => {
                                                let x = this.state.my_services;
                                                x[service].items[index] = value;

                                                this.setState({
                                                  my_services: x
                                                })
                                              }}
                                            />
                                          </section>

                                          {
                                            this.state.my_services[service].items.length > 1 ?
                                              <section className="col-sm-2 pt-2vw font-1-7rem">
                                                <IconButton onClick={this.removeRoomItem.bind(this, service, index)}>
                                                  <i className="material-icons warn-fg">
                                                    delete
                                                  </i>
                                                </IconButton>
                                              </section> 
                                            : null
                                          }

                                          {
                                            index == this.state.my_services[service].items.length - 1 ?
                                              <section className="col-sm-2 pt-2vw font-1-7rem">
                                                <IconButton onClick={this.addItem.bind(this, service)}>
                                                  <i className="material-icons link-fg">
                                                    add
                                                  </i>
                                                </IconButton>
                                              </section> 
                                            : null
                                          }
                                          <br/>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </section> 
                            </div>
													: null
												}
											</section>
										)
									}) 
								: <h6>No Services available, right now :(</h6>
							}
						</div>
					</form>
				</div>
			</Box>
		)
	}
}


// WEBPACK FOOTER //
// ./components/services/ManageServicesComponent.js